import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'component-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {}